import { render, staticRenderFns } from "./CreateOrUpdateLevelForm.vue?vue&type=template&id=2cd60588&scoped=true"
import script from "./CreateOrUpdateLevelForm.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateLevelForm.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateLevelForm.vue?vue&type=style&index=0&id=2cd60588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd60588",
  null
  
)

export default component.exports